import type { AppLocale } from '@/i18n/locales'
import { buffMessages } from '@/i18n/buffs'
import { speechLocale } from './system-voices'

export function noticeText(name: string, locale: AppLocale): string {
  return buffMessages[speechLocale(locale)].nearingNotice.replace('{name}', () => name.trim())
}
